/**
 * 常用函数库插件
 */
var directive = {};
directive.install = function (Vue, options) {
    Vue.directive('scrollbar', {
        inserted: function (el) {
            options.Scrollbar.init(el);
        }
    })
}
module.exports = directive;


// WEBPACK FOOTER //
// ./src/utils/directive.js